/**
* Constants for Trade Plan actions.
* URL in these constants are having dynamic variables
* wrapped in {}, replace them with original dynamic variables
* in order to send API requests.
*/


/** Trade Plan List*/
export const TRADE_PLAN_LIST_URL =
  "/scheme-planning/ims/tradeplan/tradePlanHeaderList?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const TRADE_PLAN_ADD_URL = "/scheme-planning/ims/tradeplan/saveTradePlan";
export const TRADE_PLAN_DETAIL_URL = "/scheme-planning/ims/tradeplan/getBytradePlanId?tradePlanId={tradePlanId}";
export const TRADE_PLAN_DELETE_URL =
  "/scheme-planning/ims/tradeplan/deleteTradePlan?tradePlanNumber={tradePlanNumber}";

/** Trade Plan Budget Head*/
export const TRADE_PLAN_LISTING_BUDGET_HEAD_URL = "/scheme-planning/ims/tradeplan/getBudgetHeads?tradePlanNumber={tradePlanNumber}";
export const TRADE_PLAN_ADD_BUDGET_HEAD_URL = "/scheme-planning/ims/tradeplan/createBudgetHead";
export const TRADE_PLAN_UPDATE_BUDGET_HEAD_URL = "/scheme-planning/ims/tradeplan/createBudgetHead";
export const TRADE_PLAN_DELETE_BUDGET_HEAD_URL = "/scheme-planning/ims/tradeplan/deleteBudgetHead?{payload}";

/** Trade Plan Sales Details */
export const TRADE_PLAN_GET_SALES_DETAILS_URL = "/scheme-planning/ims/tradeplan/getTradePlanSalesDetails?tradePlanNumber={tradePlanHdrId}";

/** Trade Plan Detail */
export const TRADE_PLAN_LISTING_PLAN_DETAIL_HEAD_URL = "/scheme-planning/ims/tradeplan/getPlanDetails?tradePlanNumber={tradePlanNumber}&tradePlanBudgetHeadId={tradePlanBudgetHeadId}";
export const TRADE_PLAN_RESET_PLAN_DETAIL_URL = "/scheme-planning/ims/tradeplan/resetPlanDetails?budgetHeadId={budgetHeadId}";
export const TRADE_PLAN_SAVE_PLAN_DETAIL_URL = "/scheme-planning/ims/tradeplan/create";

/** Trade Plan Net Sales */
export const TRADE_PLAN_LISTING_NET_SALES_HEAD_URL = "/scheme-planning/ims/tradeplan/getNetSales?tradePlanNumber={tradePlanNumber}";

/** Sales Deduction Plan */
export const TRADE_PLAN_GET_SALES_DEDUCTION_PLAN_URL = "/scheme-planning/ims/tradeplan/getSalesDeduction?tradePlanNumber={tradePlanHdrId}";
